import { useQuery } from "@tanstack/react-query";

import { getAllPartners } from "services";

import { GET_ALL_PARTNERS } from "consts";

import { AllPartnersResponse } from "models";

export const useGetPartners = () =>
  useQuery<AllPartnersResponse>({
    queryKey: [GET_ALL_PARTNERS],
    queryFn: () => getAllPartners(),
    refetchOnMount: "always",
  });
